export default __webpack_public_path__ + "6ad8ef5ca6ffdaf68723abf0914e5883.png";